<mat-tab-group
  mat-align-tabs="start"
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="selectedIndexChanged($event)"
  [class.loading]="selectedTemplateType === null">
  <mat-tab>
    <ng-template matTabLabel>
      <span translate="parameters/message-templates/whatsapp"></span>
    </ng-template>
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="multipleCommonTablesTemplate"></ng-container>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span translate="parameters/message-templates/kakaotalk"></span>
    </ng-template>
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="multipleCommonTablesTemplate"></ng-container>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<ng-template #multipleCommonTablesTemplate>
  <div [ngSwitch]="selectedTemplateType">
    <app-whatsapp-templates *ngSwitchCase="0"></app-whatsapp-templates>
    <app-kakaotalk-templates *ngSwitchCase="1"></app-kakaotalk-templates>
    <app-loader *ngSwitchDefault></app-loader>
  </div>
</ng-template>
